import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiBook, FiHeart, FiUsers, FiStar } = FiIcons;

const About = () => {
  const values = [
    {
      icon: FiBook,
      title: 'Biblical Teaching',
      description: 'We believe in the authority of Scripture and teach from the Word of God.'
    },
    {
      icon: FiHeart,
      title: 'Love & Compassion',
      description: 'We strive to show Christ\'s love through our actions and service to others.'
    },
    {
      icon: FiUsers,
      title: 'Community',
      description: 'We foster a welcoming environment where everyone can find their place.'
    },
    {
      icon: FiStar,
      title: 'Excellence',
      description: 'We pursue excellence in all we do to honor God and serve His people.'
    }
  ];

  return (
    <section id="about" className="py-20 bg-gray-50 dark:bg-gray-900 transition-colors duration-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 dark:text-white mb-6">
              About Our
              <span className="block text-blue-600 dark:text-blue-400">Church Family</span>
            </h2>
            
            <p className="text-lg text-gray-600 dark:text-gray-300 mb-6 leading-relaxed">
              Southern Saviours Church has been a cornerstone of faith in Port Harcourt for over 15 years. 
              We are a diverse congregation united by our love for Christ and commitment to serving others.
            </p>
            
            <p className="text-lg text-gray-600 dark:text-gray-300 mb-8 leading-relaxed">
              Our mission is to create a welcoming environment where people can encounter God, grow in their faith, 
              and discover their purpose in life. We believe that everyone has a place in God's family.
            </p>

            <div className="bg-blue-600 dark:bg-blue-500 text-white p-6 rounded-lg">
              <h3 className="text-xl font-semibold mb-2">Our Mission</h3>
              <p className="text-blue-100 dark:text-blue-50">
                To make disciples of Jesus Christ who love God, love others, and serve the world.
              </p>
            </div>
          </motion.div>

          {/* Image */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="relative"
          >
            <img
              src="https://images.unsplash.com/photo-1438232992991-995b7058bbb3?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
              alt="Church Community"
              className="rounded-lg shadow-xl w-full h-96 object-cover"
            />
            <div className="absolute -bottom-6 -left-6 bg-yellow-400 dark:bg-yellow-300 text-black p-6 rounded-lg shadow-lg">
              <h4 className="font-bold text-lg">Join Us</h4>
              <p className="text-sm">Every Sunday 10 AM</p>
            </div>
          </motion.div>
        </div>

        {/* Values Grid */}
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          viewport={{ once: true }}
          className="mt-20"
        >
          <h3 className="text-3xl font-bold text-center text-gray-900 dark:text-white mb-12">Our Core Values</h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {values.map((value, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="text-center bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md hover:shadow-lg transition-all duration-300"
              >
                <div className="w-16 h-16 bg-blue-100 dark:bg-blue-900 rounded-full flex items-center justify-center mx-auto mb-4">
                  <SafeIcon icon={value.icon} className="w-8 h-8 text-blue-600 dark:text-blue-400" />
                </div>
                <h4 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">{value.title}</h4>
                <p className="text-gray-600 dark:text-gray-300">{value.description}</p>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default About;